import { Link } from "react-router-dom";
import { StoreHeader } from './StoreHeader';
import { StoreFooter } from './StoreFooter';
import { useEffect } from 'react';

export function PressureCookerPlug() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <article className="mx-auto max-w-3xl px-4 py-10 text-stone-800">
      <StoreHeader />
      <header className="mb-10">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-emerald-900">
          Pressure Cooker Plug 🍲
        </h1>
        <p className="mt-2 text-lg text-stone-700">
          Beans Bila Drama!
        </p>
        <p className="mt-1 text-sm italic text-stone-500">
          Megamart Plug — shopping tips with Nairobi flavor, no lectures.
        </p>
      </header>

      {/* Intro */}
      <section className="mb-10 space-y-4 leading-relaxed">
        <p>
          Story ya kupika maharagwe for 3 hours imeisha. Pressure cooker inakuja
          kama <em>rescue team</em> — inashika gas vizuri, inapika haraka, na
          inakupea results za hotel bila stress.
        </p>
        <p>
          Hii ni life hack ya <strong>hustler kitchens</strong>. Karibu kwenye{" "}
          <strong>Megamart Plug</strong> — leo tunapiga breakdown ya safety,
          features, recipes, na vile utachagua cooker bila kuumia kwa budget.
        </p>
      </section>

      {/* Safety */}
      <section className="mb-12">
        <h2 className="mb-4 text-2xl font-bold text-emerald-900">
          Safety & Usage
        </h2>

        <ul className="space-y-3 pl-5 list-disc">
          <li>
            <strong>Usifungue kabla pressure ishuke:</strong> Subiri valve ishuke,
            alafu ufungue kama CEO.
          </li>
          <li>
            <strong>Usijaze hadi brim:</strong> Acha space ya steam kufanya kazi.
          </li>
          <li>
            <strong>Gasket check:</strong> Rubber ring ikichoka, badilisha —
            ndio seal iwe tight kama budget ya end month.
          </li>
          <li>
            <strong>Liquid ni lazima:</strong> Bila maji, cooker haisongi.
          </li>
        </ul>

        <p className="mt-4 text-sm text-stone-600">
          <strong>Megamart Tip:</strong> Tumia <em>quick release</em> kwa veggies,
          <em> natural release</em> kwa beans — texture itakuwa top tier.
        </p>
      </section>

      {/* Features */}
      <section className="mb-12">
        <h2 className="mb-6 text-2xl font-bold text-emerald-900">
          Key Features & What They Do
        </h2>

        <div className="grid gap-6 md:grid-cols-2">
          {[
            {
              title: "Pressure Settings",
              desc: "Low kwa delicate foods, High kwa maharagwe na nyama.",
            },
            {
              title: "Safety Valve",
              desc: "Auto steam release — hakuna explosions, only vibes.",
            },
            {
              title: "Preset Programs",
              desc: "Beans, rice, stew — bonyeza tu.",
            },
            {
              title: "Keep-Warm Mode",
              desc: "Inashikilia moto bila kuchoma.",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm"
            >
              <h3 className="font-semibold text-stone-900">{item.title}</h3>
              <p className="mt-1 text-sm text-stone-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits */}
      <section className="mb-12">
        <h2 className="mb-4 text-2xl font-bold text-emerald-900">
          Benefits — Why It’s the Plug
        </h2>

        <ul className="space-y-3 pl-5 list-disc">
          <li>
            <strong>Speed:</strong> Maharagwe inakuwa soft faster than Nairobi
            traffic inachemka.
          </li>
          <li>
            <strong>Energy Saving:</strong> Gas haitapotea — wallet itasmile.
          </li>
          <li>
            <strong>Consistency:</strong> Results zinakuwa predictable.
          </li>
          <li>
            <strong>Versatility:</strong> Pilau, stew, githeri — one pot, many wins.
          </li>
        </ul>
      </section>

      {/* Recipes */}
      <section className="mb-14">
        <h2 className="mb-6 text-2xl font-bold text-emerald-900">
          Quick Recipes (Hustler Edition)
        </h2>

        <div className="space-y-5">
          {[
            {
              title: "Beans & Maize (Githeri)",
              desc: "Soak, add water + salt + onions, High pressure 25–30 mins, natural release. Serve na avocado.",
            },
            {
              title: "Beef Stew",
              desc: "Brown beef, add tomatoes + spices + water, High pressure 20 mins, quick release. Chapati ikuje juu yake.",
            },
            {
              title: "Rice (Pilau Lite)",
              desc: "Sauté onions + spices, add rice + water, Low pressure 6–8 mins, natural release. Neighbors watashangaa.",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm"
            >
              <h3 className="font-semibold text-stone-900">{item.title}</h3>
              <p className="mt-1 text-sm text-stone-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Budget Guide */}
      <section className="mb-14">
        <h2 className="mb-6 text-2xl font-bold text-emerald-900">
          Budget Guide 💸
        </h2>

        <div className="grid gap-6 md:grid-cols-3">
          {[
            {
              title: "Entry-Level",
              desc: "Manual controls, basic safety.",
              link: "/products?search=pressure%20cooker%20budget",
            },
            {
              title: "Mid-Range",
              desc: "Digital presets, better build.",
              link: "/products?search=pressure%20cooker%20digital",
            },
            {
              title: "Premium (Smart)",
              desc: "App control, multi-function.",
              link: "/products?search=smart%20pressure%20cooker",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm"
            >
              <h3 className="font-semibold text-stone-900">{item.title}</h3>
              <p className="mt-1 text-sm text-stone-600">{item.desc}</p>
              <Link
                to={item.link}
                className="mt-3 inline-block text-sm font-semibold text-red-600 hover:underline"
              >
                Browse options →
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="mb-16">
        <div className="rounded-2xl border border-stone-200 bg-stone-50 p-6">
          <h3 className="text-xl font-bold text-emerald-900">
            Ready to Cook Like a Pro?
          </h3>
          <p className="mt-2">
            Kama unataka kupika haraka bila drama ya gas, pressure cooker ndio
            plug. <strong>Megamart</strong> iko na options zote.
          </p>
          <Link
            to="/products?search=pressure%20cooker"
            className="inline-flex mt-4 items-center justify-center rounded-md
                       bg-red-600 px-6 py-2 text-white font-semibold
                       hover:bg-red-700 transition"
          >
            Shop Pressure Cookers on Megamart.co.ke
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t pt-6 text-sm text-stone-600">
        Megamart Plug — product guides, care tips, and Nairobi kitchen hacks.{" "}
        <Link to="/plug" className="font-semibold text-red-600 hover:underline">
          Discover more guides
        </Link>
        .
      </footer>
      <StoreFooter />
    </article>
  );
}
